import { render, staticRenderFns } from "./payment-review.vue?vue&type=template&id=0c96fe44&"
import script from "./payment-review.vue?vue&type=script&lang=js&"
export * from "./payment-review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports